import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const painPoints = ['Horas mirando videos de YouTube sin dar el primer paso', 'Cada mes prometés empezar tu emprendimiento y no empezás', 'Talento y manos hábiles pero sin dirección ni sistema', 'Ves cómo otros venden muebles que vos podrías fabricar', 'Dejás el cuerpo en el laburo pero tu salario no cambia'];
export function PainPointsSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-199">
      <div className="max-w-4xl mx-auto" data-id="element-200">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-12" data-id="element-201">
          Si estás cansado de depender de un sueldo,{' '}
          <br className="hidden md:block" data-id="element-202" />
          <span className="text-brand-amber" data-id="element-203">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-6 mb-8 bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-204">
          {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-205">
              <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-206" />
              <p className="text-xl font-medium text-gray-800" data-id="element-207">{point}</p>
            </div>)}
        </div>

        <div className="bg-amber-50 p-8 rounded-2xl border border-amber-200 mb-12 space-y-6" data-id="element-208">
          <div className="flex items-start gap-4" data-id="element-209">
            <span className="text-2xl flex-shrink-0 mt-1" data-id="element-210">💪</span>
            <p className="text-lg font-bold text-gray-800" data-id="element-211">
              Pasás horas dejando el cuerpo, pero tu salario no cambia aunque
              des todo de vos.
            </p>
          </div>
          <div className="flex items-start gap-4" data-id="element-212">
            <span className="text-2xl flex-shrink-0 mt-1" data-id="element-213">🔩</span>
            <p className="text-lg font-bold text-gray-800" data-id="element-214">
              Tenés mano firme, constancia y ganas, pero nadie te mostró cómo
              convertir tu trabajo en algo propio.
            </p>
          </div>
          <div className="flex items-start gap-4" data-id="element-215">
            <span className="text-2xl flex-shrink-0 mt-1" data-id="element-216">🪚</span>
            <p className="text-lg font-bold text-gray-800" data-id="element-217">
              Sabés lo que es ensuciarte las manos, pero no lo que se siente
              vivir de lo que creás.
            </p>
          </div>
          <div className="flex items-start gap-4" data-id="element-218">
            <span className="text-2xl flex-shrink-0 mt-1" data-id="element-219">🔥</span>
            <p className="text-lg font-bold text-brand-rust" data-id="element-220">
              No necesitás más fuerza. Necesitás dirección, guía y un plan
              rentable.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-221">
          <div className="max-w-xl mx-auto" data-id="element-222">
            <CTAButton text="→ QUIERO DEJAR DE DEPENDER DE UN SUELDO" href="#compra" data-id="element-223" />
          </div>
        </div>
      </div>
    </section>;
}